<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <span>حداقل سفارش:</span>
          <span>{{ productPriceDetails?.minimumOrderVolume }}</span>
           <span>&nbsp{{ productPriceDetails?.measurementUnitDisplayText }}</span>
         
        </v-col>
        <v-col cols="12">
          <span>واحد فروش:</span>
          <span>&nbsp{{ productPriceDetails?.measurementUnitDisplayText }}</span>
          <span>- {{ productPriceDetails?.measurementUnitProperName }}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-data-table
          :items="productPriceDetails?.activePriceItems"
          :headers="priceItemHeaders"
          class="elevation-1"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:[`item.price`]="{ item }">
            <span>{{ item.price | priceSplitter }}</span>
          </template>
          <template v-slot:[`item.fromQty`]="{ item }">
            <span>{{ item.fromQty }}</span>
            <span>&nbsp{{ productPriceDetails?.measurementUnitDisplayText }}</span>
          </template>
          <template v-slot:[`item.toQty`]="{ item }">
             <span>{{ item.toQty }} </span>
            <span v-if="item.toQty">&nbsp{{ productPriceDetails?.measurementUnitDisplayText }}</span>
          </template>
        </v-data-table>
      </v-row>
      <v-row class="mt-5">
        <v-card tile>
          <v-card-title><h3>سوابق تغییرات قیمت</h3></v-card-title>

          <v-expansion-panels accordion>
            <v-expansion-panel
              v-for="(historyItem, i) in productPriceDetails?.archivedPriceList"
              :key="i"
            >
              <v-expansion-panel-header>{{
                historyItem.createdTimeUtc | moment
              }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12">
                    <span>حداقل سفارش:</span>
                    <span>حداقل سفارش:</span>
                    <span>{{ historyItem?.minimumOrderVolume }}</span>
                  </v-col>
                  <v-col cols="12">
                    <span>واحد فروش</span>
                    <span>{{ historyItem?.measurementUnitDisplayText }}</span>
                    <span>- {{ historyItem?.measurementUnitProperName }}</span>
                  </v-col>
                  <v-col cols="12">
                    <span class="mr-1 ml-1">توضیحات :</span>
                    <span class="mr-2 ml-2">
                      {{ historyItem?.description }}
                    </span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-data-table
                    :items="historyItem?.archivedPriceItemList"
                    :headers="priceItemHeaders"
                    class="elevation-1"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:[`item.price`]="{ item }">
                      <span>{{ item.price | priceSplitter }}</span>
                    </template>
                    <template v-slot:[`item.fromQty`]="{ item }">
                      <span>{{ item.fromQty }}</span>
                      <span>{{ historyItem?.measurementUnitDisplayText }}</span>
                    </template>
                    <template v-slot:[`item.toQty`]="{ item }">
                      <span>{{ historyItem?.measurementUnitDisplayText }}</span>
                    </template>
                  </v-data-table>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer> </v-spacer>

      <v-btn @click="closePriceDetailModal()" color="primary">بستن</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
const supplierProductRepository = RepoFactory.get('supplierProduct');
import Helper from '@/core/helpers';
import { stringify } from 'qs';
export default {
  components: {},
  props: {
    supplierProductId: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      ProductPriceValid: true,
      productPriceDetails: null,

      periceRanges: [
        {
          title: 'Start',
          displayName: 'حداقل خرید',
        },
        {
          title: 'Middle',
          displayName: 'خرید متوسط  ',
        },
        {
          title: 'End',
          displayName: 'خرید عمده',
        },
      ],
      priceItemHeaders: [
        { sortable: true, text: 'نوع قیمت ', value: 'priceRangeTitle' },
        { sortable: true, text: 'از ', value: 'fromQty' },
        { sortable: true, text: 'تا ', value: 'toQty' },
        { sortable: true, text: 'قیمت- ریال  ', value: 'price' },
      ],
    };
  },
  created() {
    this.showPriceDetails();
  },
  computed: {
    productBaseUrl() {
      return this.$store.getters.productBaseUrl;
    },
    merchantId() {
      return this.$store.getters.currentMerchant;
    },
  },
  methods: {
    closePriceDetailModal() {
      this.$emit('closePriceModal');
    },
    showPriceDetails() {
      const loader = this.$loading.show();
      supplierProductRepository
        .getSupplierProductPrice(this.supplierProductId, this.productBaseUrl)
        .then((res) => {
          this.productPriceDetails = res.data;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => loader.hide());
    },
    fillValueInput(data) {
      if (data) {
      }
    },
  },
  watch: {
    supplierProductId(value) {
      this.showPriceDetails();
    },
  },
};
</script>

<style></style>
